import { forwardRef, type ComponentPropsWithoutRef, type ReactNode } from 'react';
import clsx from 'clsx';

import {
  FILTER_OPTION_LIST_SHELL_CLASS,
  FILTER_SCROLLABLE_LIST_CLASS,
} from './filterPanelStyles';

type FilterScrollableListProps = ComponentPropsWithoutRef<'div'> & {
  children: ReactNode;
};

/** Scrollable filter option list shell — shared by Fleet Manager, Reports, and Exploration. */
const FilterScrollableList = forwardRef<HTMLDivElement, FilterScrollableListProps>(
  function FilterScrollableList({ children, className, ...props }, ref) {
    return (
      <div
        ref={ref}
        className={clsx(FILTER_OPTION_LIST_SHELL_CLASS, FILTER_SCROLLABLE_LIST_CLASS, className)}
        {...props}
      >
        {children}
      </div>
    );
  }
);

export default FilterScrollableList;
